import { connectHook } from '../../connect-hook.js';
import { Checkbox } from './checkbox.js';
import { useCheckbox } from './checkbox-hook.js';

export default connectHook(Checkbox, useCheckbox);
